import { render, staticRenderFns } from "./workflowItemList.vue?vue&type=template&id=5bed45fc&scoped=true&"
import script from "./workflowItemList.vue?vue&type=script&lang=js&"
export * from "./workflowItemList.vue?vue&type=script&lang=js&"
import style0 from "./workflowItemList.vue?vue&type=style&index=0&id=5bed45fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bed45fc",
  null
  
)

export default component.exports